module.exports = __webpack_public_path__ + "img/director-work-icon8.294ef8d5.png";